module.exports = __webpack_public_path__ + "img/settings-plus.3faa509d.svg";